/**
 * useUserDisplayName
 *
 * The logged-in user's display name, in priority order: JWT `name` claim ->
 * first/last name from `fetchUserDetails` -> email. Shared so every place
 * that shows "the user" (the header's user menu, the settings welcome
 * greeting) resolves it identically.
 */
import type { ComputedRef } from 'vue';
import { useAuth } from './useAuth';
import { useAuthStore } from '@/stores';

export function useUserDisplayName(): ComputedRef<string> {
  const { user } = useAuth();
  const authStore = useAuthStore();

  return computed(() => {
    if (user.value?.name && user.value.name.trim()) return user.value.name.trim();
    if (authStore.userDetails?.first_name || authStore.userDetails?.last_name) {
      return ((authStore.userDetails.first_name ?? '') + ' ' + (authStore.userDetails.last_name ?? '')).trim();
    }
    if (user.value?.email) return user.value.email;
    if (authStore.userDetails?.email) return authStore.userDetails.email;
    return '';
  });
}
